import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Link as MuiLink,
  makeStyles,
  Switch,
  TextField,
  Theme,
  Typography,
  Paper,
  Button,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import { PrintSharp, Check, Close } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { getPrintFile, searchData } from "src/app-redux/common-actions";
import { getAllFileCompressionConfigs } from "src/app-redux/configuration/actions/configurationActions";
import { useAppSelector } from "src/app-redux/hooks";
import {
  createVehicleInspectionWeight,
  deleteVehicleInspectionWeight,
  getLocationAtTerminal,
  updateVehicleInspectionWeight,
} from "src/app-redux/vehicle/actions/vehicleActions";
import {
  loader as vehicleLoader,
  selectLocationAtTerminal,
  setSelectedVehicleWeightId,
} from "src/app-redux/vehicle/vehicleSlice";
import { filteryByArr, weightUnitForInspection } from "src/common/utils/app.dropdowns";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";

import TabHeader from "src/components/TabHeader/TabHeader";
import * as Yup from "yup";
import { VehicleManagementRoute } from "../../vehicle-management.routes";
import { columns } from "./components/columns";
import Drawer from "./components/Drawer";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import { validationNumber } from "src/common/utils/formValidation";
import { Tooltip } from "@mui/material";
import { filterBy } from "src/common/utils/helpers";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  readOnyTitle: {
    fontWeight: "bold",
  },
}));

interface Props {}

export function InspectionWeight({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = VehicleManagementRoute.title;
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const pageHeading = "Vehicle Inspection Weight";
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const [forceSave, setForceSave] = useState<any>(false);
  const [isEditMode, setisEditMode] = React.useState(false);

  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [vehicleStatusArr, setvehicleStatusArr] = React.useState<any[]>([]);
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const weightUnitArr = weightUnitForInspection;
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const receiptLoader: any = useAppSelector(gateEntryLoader);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const [fileToUpload, setFileToUpload] = React.useState<any[]>([]);
  const [validFileTypes, setValidFileTypes] = React.useState<any>([]);
  const [validFileSize, setValidFileSize] = React.useState(0);
  const [isValidFileType, setIsValidFileType] = React.useState<boolean[]>([]);
  const [isValidFileSize, setIsValidFileSize] = React.useState<boolean[]>([]);
  let fileTypesArr: any[] = [];
  let maxFileSize = 0;
  const [minWeightValue, setMinWeightValue] = useState<number>(0);
  const [deleteRemarks, setDeleteRemarks] = useState("");
  const [isDeleteMode, setIsDeleteMode] = React.useState(false);

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    const size: boolean[] = [];
    const type: boolean[] = [];

    acceptedFiles.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(fileTypesArr.includes(`.${split[split.length - 1]}`.toLowerCase()));
      size.push(file.size / (1024 * 1024) <= maxFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
    setFileToUpload(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    getFileConfig();
  }, []);

  const getFileConfig = async () => {
    const res: any = await dispatch(getAllFileCompressionConfigs());
    if (res.payload && res.payload[0]) {
      setValidFileTypes(res.payload[0].fileTypes.split(","));
      setValidFileSize(res.payload[0].fileSizeThreshold);
      fileTypesArr = res.payload[0].fileTypes.split(",");
      maxFileSize = res.payload[0].fileSizeThreshold;
    }
  };

  // Redux
  const locationAtTerminalArr: any = useAppSelector(selectLocationAtTerminal);

  /* AXIOS Calls */
  const getVehicleStatusListing = async () => {
    let results: any = [];
    try {
      setLoader(true);
      results = await fetchWrapper.get("vehicle-status-get-all?ShowIsActive=true");
      if (results.isSuccess == true) {
        setvehicleStatusArr(results.value);
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
    }
  };
  const getVehicleStatusByVehicleId = async (id: number, regNum: string) => {
    let results: any = [];
    try {
      setLoader(true);
      results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);
      if (results.isSuccess == true) {
        setValues({
          ...values,
          vehicleStatusId: results.value.vehicleStatusId,
          registrationNumber: regNum,
          weight:
            results.value.vehicleWeightUnit === "Ton"
              ? Number(results.value.vehicleWeight) * 1000
              : Number(results.value.vehicleWeight),
          cargoType: results.value.cargoTypeName,
          consignmentType: results.value.consignmentTypeName,
          vehicleType: results.value.vehicleType,
          entryDateTime: results.value.dateTime,
          totalWeight: formik.initialValues.totalWeight,
          netWeight: formik.initialValues.netWeight,
          startTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
        });
      }
      setMinWeightValue(Number(results.value.vehicleWeight));
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
    }
  };
  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "comment"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "serialNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return <div>{renderedCellValue ? renderedCellValue : "--"}</div>;
              },
            }
          : column.accessorKey === "vehicleInProgress"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleInProgress ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleInProgress ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "weight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return `${row.original.weight.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })} ${row.original.weightUnit ? row.original.weightUnit : "KG"}`;
              },
            }
          : column.accessorKey === "totalWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return `${row.original.totalWeight.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })} ${row.original.weightUnit ? row.original.weightUnit : "KG"}`;
              },
            }
          : column.accessorKey === "netWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return `${row.original.netWeight.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })} ${row.original.weightUnit ? row.original.weightUnit : "KG"}`;
              },
            }
          : column.accessorKey === "files"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <MuiLink
                    className="customMuiLink"
                    onClick={() => {
                      dispatch(
                        setSelectedVehicleWeightId({
                          weightId: row.original.vehicleWeightId,
                          regNo: row.original.registrationNumber,
                          isNodWeightFile: false,
                        })
                      );
                      setisDrawerOpen(true);
                    }}
                  >
                    View
                  </MuiLink>
                );
              },
            }
          : column.accessorKey === "actions"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setIsDirty(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                    >
                      Edit
                    </NewCommonButton>
                    <NewCommonButton
                      onClick={() => {
                        handleDelete(row.original);
                      }}
                      icon={<DeleteIcon />}
                    >
                      Delete
                    </NewCommonButton>
                    <NewCommonButton
                      onClick={() => {
                        setSelectedRecordId(row.original?.gatePassId);
                        setIsOpenPrintDailog(true);
                      }}
                      icon={<PrintSharp />}
                      isGreen
                    >
                      Print
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  const validationSchema = Yup.object().shape({
    registrationNumber: Yup.string()
      .max(20, "Maximum 20 characters allowed")
      .required("This field is required"),
    refNum: Yup.string().max(50, "Maximum 50  characters allowed"),
    comment: Yup.string().max(3000, "Maximum 3000 characters allowed"),
    weight: Yup.number()
      .required("This field is required")
      .max(10000000000, "Maximum 10 digits allowed"),
    totalWeight: Yup.number()
      .required("This field is required")
      .min(minWeightValue, `Minimum ${minWeightValue} is allowed.`)
      .max(10000000000, "Maximum 10 digits allowed"),
    weightUnit: Yup.string().required("This field is required"),
    terminalLocationId: Yup.string().required("This field is required"),
  });
  const formik = useFormik({
    initialValues: {
      InProgressVehiclesDataOnly: false,
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      vehicleWeightId: 0,
      terminalLocationId: "",
      registrationNumber: "",
      vehicleStatusId: "",
      refNum: "",
      comment: "",
      weight: "",
      totalWeight: "",
      netWeight: "",
      weightUnit: "KG",
      cargoType: "",
      consignmentType: "",
      vehicleType: "",
      entryDateTime: "",
      startTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
      endTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (values.vehicleStatusId == "" || values.vehicleType == "") {
        dispatch(
          addNotificationAction({
            message: "Select vehicle number first!",
            options: { variant: "error" },
          })
        );
        return;
      }
      setLoader(true);
      const form = new FormData();
      form.append("terminalLocationId", values.terminalLocationId);
      form.append("registrationNumber", values.registrationNumber);
      form.append("vehicleStatusId", values.vehicleStatusId);
      form.append("refNum", values.refNum);
      form.append("comment", values.comment);
      form.append("weight", values.weight);
      form.append("totalWeight", values.totalWeight);
      form.append("netWeight", values.netWeight);
      form.append("weightUnit", values.weightUnit);
      form.append("forceSave", forceSave);

      fileToUpload.length
        ? fileToUpload.forEach((file) => {
            form.append("files", file);
          })
        : form.append("files", "");

      let res: any;
      if (isEditMode) {
        form.append("vehicleWeightId", values.vehicleWeightId);
        res = await dispatch(updateVehicleInspectionWeight(form));
      } else {
        form.append("startTime", values.startTime);
        form.append("endTime", moment().format("YYYY-MM-DDTHH:mm:ss"));
        res = await dispatch(createVehicleInspectionWeight(form));
        if (res.payload?.isWeightAlreadyExist && !forceSave) {
          setIsOpenSaveDailog(true);
        }
      }
      if ((isEditMode && res) || !res.payload?.isWeightAlreadyExist) {
        handleSearch();
        actions.setSubmitting(false);
        actions.resetForm();
        resetSearch();
        setFileToUpload([]);
        setIsValidFileType([]);
        setIsValidFileSize([]);
        setIsDirty(false);
        getLocations();
        setForceSave(false);
      }
      setLoader(false);
    },
  });
  const { values, setValues } = formik;
  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-vehicle-weights", JSON.stringify(body))
      );
      const record = results.vehicleWeights;
      if (record) {
        const transformedData = record.map((data: any, index: any) => {
          return {
            ...data,
            vehicleWeightId: data.id,
            id: index,
          };
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const resetSearch = () => {
    setisEditMode(false);
    setValues({ ...formik.initialValues, terminalLocationId: values.terminalLocationId });
    setIsDirty(false);
    setFileToUpload([]);
    setMinWeightValue(0);
  };
  const [resetHandler, setResetHandler] = useState(false);
  const resetGrid = () => {
    setValues({
      ...formik.values,
      InProgressVehiclesDataOnly: formik.initialValues.InProgressVehiclesDataOnly,
      filterBy: formik.initialValues.filterBy,
      startDate: formik.initialValues.startDate,
      endDate: formik.initialValues.endDate,
    });
    setIsCustomDate(false);
    setResetHandler(true);
  };
  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    getVehicleStatusListing();
    handleSearch();
    getLocations();
    setResetHandler(false);
  }, [resetHandler]);
  const getLocations = async () => {
    const res: any = await dispatch(getLocationAtTerminal());
    formik.setFieldValue(
      "terminalLocationId",
      res.payload.find((st: any) => st.name === "Weighbridge")?.id
    );
  };
  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };
  const handleUpdateClick = (params: any) => {
    setMinWeightValue(Number(params.weight));
    formik.setFieldValue("vehicleWeightId", params.vehicleWeightId);
    formik.setFieldValue("registrationNumber", params.registrationNumber);
    formik.setFieldValue("refNum", params.refNum);
    formik.setFieldValue("comment", params.comment);
    formik.setFieldValue("weight", params.weight);
    formik.setFieldValue("netWeight", params.netWeight);
    formik.setFieldValue("totalWeight", params.totalWeight);
    formik.setFieldValue("weightUnit", params.weightUnit);
    formik.setFieldValue("cargoType", params.cargoTypeName);
    formik.setFieldValue("consignmentType", params.consignmentTypeName);
    formik.setFieldValue("vehicleType", params.vehicleType);
    formik.setFieldValue("entryDateTime", params.gateEntryTime);
    formik.setFieldValue("vehicleStatusId", params.vehicleStatusId);
    setisEditMode(true);
  };

  const [isOpenSaveDailog, setIsOpenSaveDailog] = useState<boolean>(false);
  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);
  const [deleteGridItem, setdeleteGridItem] = useState<any>("");
  const handleCloseDeleteDialog = () => {
    setIsDeleteMode(false);
    setDeleteRemarks("");
    setIsOpenDeleteDailog(false);
  };
  const handleDeleteDialog = async () => {
    setIsDeleteMode(true);
    if (deleteRemarks) {
      setIsOpenDeleteDailog(false);
      if (deleteGridItem) {
        const body = { ...deleteGridItem, deleteRemarks: deleteRemarks };

        const res: any = await dispatch(deleteVehicleInspectionWeight(body));
        if (res.payload) {
          handleSearch();
          formik.resetForm();
          setFileToUpload([]);
          setIsValidFileType([]);
          setIsValidFileSize([]);
          setIsDirty(false);
          getLocations();
        }
      }
    }
  };

  const handleDelete = (id: any) => {
    setIsOpenDeleteDailog(true);
    setdeleteGridItem(id);
  };

  const handleCloseSaveDialog = () => {
    setIsOpenSaveDailog(false);
  };

  const handleSaveDialog = async () => {
    setIsOpenSaveDailog(false);
    setForceSave(true);
    formik.submitForm();
  };

  const weightSavehandler = () => {
    formik.submitForm();
  };

  // Show prompt if the form is fully or partially filled and user wants to navigate away
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    // If prompt, when reloading or closing the tab
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleChange(e: any) {
    // Textfield ==>> e.target.value
    // Checkbox / Switch ==>> e.target.checked !== e.target._wrapperState.initialChecked

    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const removeFileFromIndex = (index: number) => {
    const upload = fileToUpload;
    upload.splice(index, 1);
    setFileToUpload(upload);

    const size: boolean[] = [];
    const type: boolean[] = [];

    fileToUpload.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(validFileTypes.includes(`.${split[split.length - 1]}`));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
  };

  const findNetWeight = async (vehicleWeight: number, totalWeight: number) => {
    await setMinWeightValue(Number(vehicleWeight));
    formik.setFieldValue(
      "netWeight",
      totalWeight && Number(totalWeight) - Number(vehicleWeight)
        ? Number(totalWeight) - Number(vehicleWeight)
        : 0
    );
  };

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (!loader && !loader2 && !isOpenSaveDailog) formik.submitForm();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [loader, loader2, isOpenSaveDailog]);

  const [isOpenPrintDailog, setIsOpenPrintDailog] = useState<boolean>(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const printReceipt = async (isDuplicate: string) => {
    setIsOpenPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm ");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-weigh-bridge-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        "Serial #": data?.serialNumber,
        Vehicle: data?.registrationNumber,
        Status: data?.vehicleStatus,
        Location: data?.terminalLocation,
        "Vehicle Weight": `${data?.weight?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })} ${data.weightUnit ? data.weightUnit : "KG"}`,
        "Total Weight": `${data?.totalWeight?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })} ${data.weightUnit ? data.weightUnit : "KG"}`,
        "Net Weight": `${data?.netWeight?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })} ${data.weightUnit ? data.weightUnit : "KG"}`,
        Cargo: data?.cargoTypeName,
        Consignment: data?.consignmentTypeName,
        "Start Time": data.startTime ? moment(data.startTime).format("DD-MM-YYYY hh:mm:ss A") : "",
        "End Time": data.endTime ? moment(data.endTime).format("DD-MM-YYYY hh:mm:ss A") : "",
        "In Progress": data.vehicleInProgress ? "Yes" : "No",
        "Reference #": data?.refNum,
        Remarks: data?.comment,
      };
    });
    return exportedRecords;
  };

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={VehicleManagementRoute.path} />
      <Backdrop className={classes.backdrop} open={loader || loader2 || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />

      {/* Dialog for Print Receipt */}
      <DuplicateReceiptDialog
        isOpen={isOpenPrintDailog}
        handleOriginal={() => {
          printReceipt("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceipt("1");
        }}
        onClose={() => {
          setIsOpenPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => weightSavehandler()}
                >
                  {isEditMode ? "Update" : "Save"}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row" justifyContent="space-between">
              <Grid item xs={12} md={8}>
                <Grid spacing={2} container direction="row">
                  <Grid item xs={12} md={6}>
                    <Box style={{ display: isEditMode ? "none" : "block" }}>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Vehicle Number"
                        placeholder="Enter Vehicle Number"
                        name="registrationNumber"
                        optionsType={vehicleRegNumberArr}
                        getOptionLabel={(option) => option.registrationNumber || ""}
                        required
                        value={
                          vehicleRegNumberArr.find(
                            (st: any) => st.registrationNumber === formik.values.registrationNumber
                          ) || null
                        }
                        onChange={(option: any) => {
                          if (
                            option &&
                            option.registrationNumber !== "" &&
                            option.vehicleId !== 0
                          ) {
                            getVehicleStatusByVehicleId(
                              option.vehicleId,
                              option.registrationNumber
                            );
                            handleChange({ target: { value: option.vehicleId } });
                          } else {
                            formik.setFieldValue("registrationNumber", "");
                            handleChange({ target: { value: null } });
                          }
                        }}
                        onKeyUp={(e: any) => {
                          setVehicleNumberLength(e.target.value.length);
                          if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                            getVehicleByRegistrationNo(e.target.value);
                            return;
                          }
                        }}
                        onKeyDownCapture={(e: any) => {
                          if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                          else handleChange(e);
                        }}
                        onPaste={(e: any) => {
                          if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                            e.preventDefault();
                            return;
                          }

                          if (e.clipboardData.getData("text").length >= 2)
                            getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                        }}
                        error={
                          formik.touched.registrationNumber &&
                          Boolean(formik.errors.registrationNumber)
                        }
                        helperText={
                          formik.touched.registrationNumber && formik.errors.registrationNumber
                        }
                      />
                    </Box>
                    <Box style={{ display: isEditMode ? "block" : "none" }}>
                      <TextField
                        className={"customTextField"}
                        required
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Vehicle Number"
                        name="registrationNumber"
                        id="registrationNumber"
                        placeholder="Enter Vehicle Number"
                        disabled={true}
                        value={formik.values.registrationNumber}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className="customTextField"
                        type="number"
                        required
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Vehicle Weight"
                        name="weight"
                        placeholder="Enter Vehicle Weight"
                        disabled={false}
                        value={formik.values.weight}
                        onChange={(e) => {
                          handleChange(e);
                          findNetWeight(Number(e.target.value), formik.values.totalWeight);
                        }}
                        onPaste={(e: any) => {
                          if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                        }}
                        error={formik.touched.weight && Boolean(formik.errors.weight)}
                        helperText={formik.touched.weight && formik.errors.weight}
                        onKeyDown={(evt) => validationNumber(evt)}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className="customTextField"
                        type="number"
                        required
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Total Weight"
                        name="totalWeight"
                        placeholder="Enter Total Weight"
                        disabled={false}
                        value={formik.values.totalWeight}
                        onChange={(e) => {
                          handleChange(e);
                          findNetWeight(formik.values.weight, Number(e.target.value));
                        }}
                        onPaste={(e: any) => {
                          if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                        }}
                        error={formik.touched.totalWeight && Boolean(formik.errors.totalWeight)}
                        helperText={formik.touched.totalWeight && formik.errors.totalWeight}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        error={formik.touched.weightUnit && Boolean(formik.errors.weightUnit)}
                        helperText={formik.touched.weightUnit && formik.errors.weightUnit}
                        label="Weight Unit"
                        placeholder="Select Weight Unit"
                        name="weightUnit"
                        optionsType={weightUnitArr}
                        getOptionLabel={(option) => option || ""}
                        required
                        value={
                          weightUnitArr.find((st: any) => st === formik.values.weightUnit) || null
                        }
                        onChange={(option: any) => {
                          if (option) {
                            formik.setFieldValue("weightUnit", option);
                            handleChange({ target: { value: option } });
                            const weightVal =
                              option === "Ton"
                                ? Number(formik.values.weight) / 1000
                                : Number(formik.values.weight) * 1000;
                            formik.setFieldValue("weight", weightVal);
                            findNetWeight(weightVal, formik.values.totalWeight);
                          } else {
                            handleChange({ target: { value: null } });
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Reference Number"
                        name="refNum"
                        placeholder="Enter Reference Number"
                        disabled={false}
                        value={formik.values.refNum}
                        onChange={handleChange}
                        error={formik.touched.refNum && Boolean(formik.errors.refNum)}
                        helperText={formik.touched.refNum && formik.errors.refNum}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box
                      {...getRootProps()}
                      border={"1px solid rgb(196 196 196)"}
                      borderRadius={5}
                      overflow={"auto"}
                      display={"flex"}
                      flexWrap={"wrap"}
                      borderColor={isDragActive ? "error.main" : "rgb(196 196 196)"}
                      style={{ cursor: "pointer" }}
                    >
                      <input {...getInputProps()} />

                      {fileToUpload.length ? (
                        fileToUpload.map((file, index) => {
                          return (
                            <div
                              key={file.name}
                              style={{
                                margin: "6.8px",
                                backgroundColor: "#E67817",
                                padding: "3px 15px 3px 5px",
                                borderRadius: "10px",
                                maxWidth: "122px",
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              <div
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: "11px",
                                  color: "white",
                                }}
                              >
                                {file.name}
                              </div>
                              <IconButton
                                aria-label="Search"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  removeFileFromIndex(index);
                                }}
                                edge="end"
                                className="icon-button-search"
                                style={{
                                  color: "white",
                                  padding: 0,
                                  marginTop: "2px",
                                  width: "10px",
                                  height: "10px",
                                  overflow: "hidden",
                                  marginRight: "2px !important",
                                }}
                              >
                                <Close />
                              </IconButton>
                            </div>
                          );
                        })
                      ) : isDragActive ? (
                        <p>Drop a file here ...</p>
                      ) : (
                        <p style={{ color: "black", margin: 9 }}>
                          {/* Drag and drop file here,or click to select a file */}
                          Upload File(s)
                        </p>
                      )}
                    </Box>
                    <Box>
                      <div style={{ color: "#f44336", marginBottom: 0 }}>
                        <ul
                          style={{
                            paddingLeft: "16px",
                            margin: 0,
                            display: isValidFileType.includes(false) ? "block" : "none",
                          }}
                        >
                          <li>
                            Only{" "}
                            {validFileTypes.map((type: any, index: number) => {
                              return index < validFileTypes.length - 1 ? `${type},` : type;
                            })}{" "}
                            files are allowed.
                          </li>
                        </ul>
                        <ul
                          style={{
                            paddingLeft: "16px",
                            margin: 0,
                            display: isValidFileSize.includes(false) ? "block" : "none",
                          }}
                        >
                          <li>File size cannot exceed {validFileSize}MB.</li>
                        </ul>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Box>
                      <TextField
                        multiline
                        rows={3}
                        rowsMax={8}
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Remarks"
                        name="comment"
                        placeholder="Enter Remarks"
                        disabled={false}
                        value={formik.values.comment}
                        onChange={handleChange}
                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                        helperText={formik.touched.comment && formik.errors.comment}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={1} variant="outlined" style={{ padding: "15px" }}>
                  <Grid spacing={1} container direction="row" justifyContent="space-between">
                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Net Weight:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.netWeight || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Type:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.vehicleType || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Status:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        {vehicleStatusArr.find((st: any) => st.id === formik.values.vehicleStatusId)
                          ?.name || "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Entry Date:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        {formik.values.entryDateTime
                          ? moment(formik.values.entryDateTime).format("DD-MM-YYYY hh:mm a") || "-"
                          : formik.values.entryDateTime || "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>
                        Location at Terminal:
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        {(formik.values.entryDateTime &&
                          locationAtTerminalArr.find(
                            (st: any) => st.id === formik.values.terminalLocationId
                          )?.name) ||
                          "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Type of Consignment:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.consignmentType || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Type of Cargo:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.cargoType || "-"}</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={3} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  name="filterBy"
                  disableClearable={true}
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || ""}
                  onChange={(row: any) => {
                    row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Vehicles"
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
                <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                  <CommonButton cssClass="customSubmitBtn" onClick={() => resetGrid()}>
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className="">
            <CommonMaterialGrid
              rows={vehicleRecord}
              columns={displayColumns}
              defaultPerPageRecord={15}
              height={550}
              isExport={isExport}
              exportHandler={exportHandler}
              filename={`Vehicle_insp_weight_${Date.now()}`}
            />
          </div>
        </CardContent>
      </Card>
      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to delete this record?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={deleteRemarks}
            onChange={(e) => {
              const { value } = e.target;
              setDeleteRemarks(value);
            }}
            error={isDeleteMode && !deleteRemarks}
            helperText={isDeleteMode && !deleteRemarks && "This field is required"}
          />
        </Box>
      </TransitionDialog>

      <TransitionDialog
        isOpen={isOpenSaveDailog}
        handleClose={handleCloseSaveDialog}
        heading={"Confirmation"}
        handleConfirm={handleSaveDialog}
      >
        Record against vehicle already present in same trip, do you want to save another one?
      </TransitionDialog>
    </div>
  );
}
